import Header from './Header.wrapper';
import { IHeader } from './Header.interfaces';

export default Header;
export { Header, IHeader };
